var React = require('react');

function B3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M18.34.07v0L0,1.62,3.34,41.93,21.68,40.4v0h0A20.22,20.22,0,0,0,18.34.07","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M27.52,31.13v0l-22.13,2L9.75,81.78l22.13-2v0h0a24.42,24.42,0,0,0-4.37-48.64","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

B3.defaultProps = {"viewBox":"0 0 54.12 81.78"};

module.exports = B3;

B3.default = B3;
